import React from "react";
import {
  Image,
  ImageBackground,
  Modal,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import style from "./style";
import globalstyle from "../../Styles/Globals/globals";
import XarxesSocials from "./XarxesSocials";
import getPointsItinerari from "../../Functions/getPointsItinerari";
import { getRecursText, getRecursURL } from "../../Functions/getRecurs";

// todo boto per superPremi
function PopUpFinal(RouterData, modalVisible, setModalVisible, token) {
  const {
    recursos,
    idioma,
    itinerari,
    itineraris,
    currentItinerari,
    projecte,
  } = RouterData.route.params;

  const navigateMostrarInventari = async () => {
    const item = await getPointsItinerari(itineraris);
    const statsPressedItinerari = item.itineraris.find(
      (e) => e.itinerari === currentItinerari.id,
    );

    setModalVisible(false);

    RouterData.navigation.navigate("Perfil", {
      ...RouterData.route.params,
      perfilImatges: statsPressedItinerari,
    });
  };

  return (
    <Modal animationType="fade" transparent={true} visible={modalVisible}>
      <View style={style.modalOutBackground}>
        <View style={[style.caixaPopUp, { height: "80%" }]}>
          <ImageBackground
            source={{
              uri: getRecursURL(
                recursos,
                "05_background_tipus2_confeti",
                idioma,
              ),
            }}
            style={style.backgroundImatges}
          >
            <TouchableOpacity
              style={globalstyle.crossBox}
              onPress={() => {
                setModalVisible(false);
              }}
            >
              <Image
                source={{
                  uri: getRecursURL(recursos, "pop_up_close_icon", idioma),
                }}
                style={style.cross}
              />
            </TouchableOpacity>
            <View
              style={{
                flex: 40,
                alignItems: "center",
                width: "85%",
                justifyContent: "center",
              }}
            >
              <Text style={[style.popUpTitleInicial]}>
                {" "}
                {getRecursText(recursos, "text_finalitzacio_itinerari", idioma)}
              </Text>
            </View>
            <View
              style={{
                flex: 50,
                alignItems: "center",
                width: "85%",
                justifyContent: "center",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  navigateMostrarInventari();
                }}
              >
                <Text style={globalstyle.botoContinuar}>
                  {getRecursText(recursos, "text_mostrar_inventari", idioma)}
                </Text>
              </TouchableOpacity>
            </View>
            {XarxesSocials(RouterData, token, {
              textSocial: encodeURI(
                itinerari["textSocial" + idioma] ||
                  projecte["textSocial" + idioma],
              ).replaceAll("#", "%23"),
              peticio: itinerari.Nom,
            })}
          </ImageBackground>
        </View>
      </View>
    </Modal>
  );
}

export default PopUpFinal;
